export default __webpack_public_path__ + "static/6-86caa4e90aaa3819ad7899e9c678f6b5.png";